module.exports = __webpack_public_path__ + "videos/Gritify_talent_final_sv.17a3151.mp4";